/**
 * Service to manage feature flags for the pif-compiler
 * This provides access to configuration flags
 * that can modify parser and validation behavior.
 */
export class FeatureFlagsService {
    constructor(flags) {
        this.flags = flags || {
            validation: {
                NODE_NUMBER_OUT_OF_RANGE: 'error',
            },
        };
    }
    /**
     * Set feature flags (useful for dynamic updates)
     * @param flags - The feature flags to set
     */
    setFeatureFlags(flags) {
        this.flags = flags;
    }
    /**
     * Get all feature flags
     * @returns A copy of the current feature flags
     */
    getFeatureFlags() {
        return { ...this.flags };
    }
}
//# sourceMappingURL=feature-flags-service.js.map